export const options = {
  type: 'bar',
  cornerRadius: 5,
  plugins: {
    topLabels: true,
    datalabels: {
      display: true,
      color: 'white',
      anchor: 'center',
      fontWeight: 'bold',
      align: 'center',
    },
  },
  legend: {
    position: 'bottom',
    align: 'start',
    labels: {
      usePointStyle: false,
      boxWidth: 12,
      boxHeight: 12,
    },
  },
  layout: {
    padding: {
      right: 90,
    },
  },
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
        display: false,
      },
    ],
    yAxes: [
      {
        display: false,
      },
    ],
  },

  tooltips: {
    callbacks: {
      title: function (tooltipItem, data) {
        return data['labels'][tooltipItem[0]['index']]
      },
    },
    caretSize: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    titleFontSize: 16,
    borderColor: '#EAE9E9',
    cornerRadius: 6,
    borderWidth: 1,
    titleFontColor: '#000',
    bodyFontColor: '#000',
    bodyFontSize: 14,
  },
}
